(function () {
  "use strict";

  var GUEST_INTENT_STORAGE_KEY = "twaArchiveRewardsGuestIntent.v1";

  function ready(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback);
      return;
    }

    callback();
  }

  function stashGuestIntent(birthday, newsletterOptIn) {
    // Only a birthday the rules accept is ever kept (assets/archive-birthday.js).
    if (birthday && window.ArchiveBirthday && !window.ArchiveBirthday.usableStashedBirthday(birthday)) {
      birthday = "";
    }

    if (!birthday && !newsletterOptIn) {
      try {
        window.localStorage.removeItem(GUEST_INTENT_STORAGE_KEY);
      } catch (error) {
        // Nothing kept, nothing to clear.
      }
      return;
    }

    try {
      var intent = {
        birthday: birthday || null,
        newsletterOptIn: Boolean(newsletterOptIn),
        capturedAt: new Date().toISOString()
      };

      window.localStorage.setItem(GUEST_INTENT_STORAGE_KEY, JSON.stringify(intent));
    } catch (error) {
      console.warn("Unable to stash Archive Rewards guest intent.", error);
    }
  }

  ready(function () {
    var form = document.querySelector("[data-guest-signup-form]");

    if (!form) {
      return;
    }

    var birthdayInput = form.querySelector("[data-guest-birthday-input]");
    var newsletterCheckbox = form.querySelector("[data-guest-newsletter-checkbox]");
    var submitButton = form.querySelector(".archive-guest-cta");
    var registerUrl = submitButton ? submitButton.dataset.guestRegisterUrl : "";
    var rules = window.ArchiveBirthday;
    var birthdayError = null;

    if (birthdayInput && rules) {
      rules.constrainInput(birthdayInput);

      // The inline message for an entered birthday the rules refuse (the field stays optional).
      birthdayError = document.createElement("p");
      birthdayError.id = "archiveGuestBirthdayError";
      birthdayError.className = "archive-guest-field__error";
      birthdayError.setAttribute("role", "alert");
      birthdayError.hidden = true;
      birthdayInput.insertAdjacentElement("afterend", birthdayError);
      birthdayInput.setAttribute(
        "aria-describedby",
        ((birthdayInput.getAttribute("aria-describedby") || "") + " " + birthdayError.id).trim()
      );
      birthdayInput.addEventListener("input", function () {
        showBirthdayError("");
      });
    }

    function showBirthdayError(message) {
      if (!birthdayError) {
        return;
      }

      birthdayError.textContent = message || "";
      birthdayError.hidden = !message;

      if (message) {
        birthdayInput.setAttribute("aria-invalid", "true");
      } else {
        birthdayInput.removeAttribute("aria-invalid");
      }
    }

    form.addEventListener("submit", function (event) {
      event.preventDefault();

      if (!registerUrl || (submitButton && submitButton.getAttribute("aria-busy") === "true")) {
        return;
      }

      var birthday = birthdayInput ? birthdayInput.value : "";

      // Optional, but an entered birthday must pass the rules before anything is kept. A date the
      // browser could not read (a partly filled picker) counts as entered.
      if (rules && birthdayInput) {
        var partlyEntered = !birthday && birthdayInput.validity && birthdayInput.validity.badInput;

        if (birthday || partlyEntered) {
          var check = rules.validateSubmission(birthday);

          if (!check.ok) {
            showBirthdayError(partlyEntered ? rules.messageFor(rules.REASONS.Malformed) : check.message);
            birthdayInput.focus();
            return;
          }

          birthday = check.iso;
        }
      }

      showBirthdayError("");
      stashGuestIntent(
        birthday,
        newsletterCheckbox ? newsletterCheckbox.checked : false
      );

      if (submitButton) {
        submitButton.setAttribute("aria-busy", "true");
      }

      window.location.href = registerUrl;
    });
  });
})();
